import script from "./SALStep1Registro.vue?vue&type=script&setup=true&lang=js"
export * from "./SALStep1Registro.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__